import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getFifthFlow = asyncThunkWrapper({ 
  model: 'fifthFlow', 
  action: 'getFifthFlow', 
  func: async () => {
    const attributes = ['id', 'email', 'issue_email', 'prompt', 'updated_at'];
    const params = { attributes };
    const response = await axios.get(`/fifth_flow`, { params });

    return response.data;
  } 
});
export const createFifthFlow = asyncThunkWrapper({ 
  model: 'fifthFlow', 
  action: 'createFifthFlow', 
  func: async (fifth_flow) => {
    const attributes = ['id', 'email', 'issue_email', 'prompt', 'updated_at'];
    const response = await axios.post(`/fifth_flow`, { fifth_flow, attributes });

    return response.data;
  } 
});
export const updateFifthFlow = asyncThunkWrapper({ 
  model: 'fifthFlow', 
  action: 'updateFifthFlow', 
  func: async (fifth_flow) => {
    const response = await axios.patch(`/fifth_flow`, { fifth_flow });

    return { status: response.status, fifth_flow };
  } 
});
export const deleteFifthFlow = asyncThunkWrapper({ 
  model: 'fifthFlow', 
  action: 'deleteFifthFlow', 
  func: async () => {
    const response = await axios.delete(`/fifth_flow`);

    return { status: response.status };
  } 
});
export const clearLocalActiveFifthFlow = createAction('fifthFlow/clearLocalActiveFifthFlow');